import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  MatchesResponse,
  MatchActionResponse,
  WSMatchRequestPayload,
  WSMatchAcceptedPayload,
} from '@app/core/api/matching';

export const MatchingActions = createActionGroup({
  source: 'Matching',
  events: {
    // Load matches
    'Load Matches': emptyProps(),
    'Load Matches Success': props<{ matches: MatchesResponse }>(),
    'Load Matches Failure': props<{ error: string }>(),

    // Respond to match (select / accept / decline — all via REST)
    'Respond To Match': props<{ proposalId: string; action: 'select' | 'accept' | 'decline' }>(),
    'Respond To Match Success': props<{ response: MatchActionResponse }>(),
    'Respond To Match Failure': props<{ error: string }>(),

    // Cancel match
    'Cancel Match': props<{ proposalId: string }>(),
    'Cancel Match Success': props<{ response: MatchActionResponse }>(),
    'Cancel Match Failure': props<{ error: string }>(),

    // Clear error
    'Clear Error': emptyProps(),

    // Reset state on logout
    'Clear Matches': emptyProps(),

    // WS incoming (kept)
    'Match Request Received': props<{ payload: WSMatchRequestPayload }>(),
    'Match Accepted Received': props<{ payload: WSMatchAcceptedPayload }>(),

    // WS navigate event
    'Navigate Received': props<{ path: string }>(),
  }
});
